<ng-container *ngIf="(currentAccount$ | async)?.isImpersonated">
    <div class="root" *transloco="let t; read: 'ui.navigation'">
        <div class="root__icon"></div>
        <div class="root__text" [innerHtml]="t('impersonated')" (clickAnchor)="impersonateStop()">
        </div>
    </div>
</ng-container>
